import { PaymentPreference } from "../../../../types/payment-preference/payment-preference.type";
import { Loader } from "../../../../_components";
import LoginRequiredView from "../../../../_components/login-required-view.component";
import Label from "../../../../_components/typography/label.typography";
import { Status } from "../../../../_store/courses/courses-reducer";
import ViewCommunityDefaultCurrency from "./component/payment-gateway-currency-component";
import { PaymentMethodSelectionComponent } from "./payment-gateway-methods";

interface CommunityPaymentsProps {
  community: any;
  user: any;
  /**
   * Payment preference details
   */
  paymentPreference: {
    preference: PaymentPreference;
    status: Status;
  };
  /**
   * Make API call to update payment preference on backend and store in redux
   */
  onPaymentPreferenceUpdate: (
    payload: any,
    onSuccess: (_: PaymentPreference) => void,
    onFailed: (_: any) => void
  ) => void;
  /**
   * Save updated community details in redux
   */
  onCommunityUpdate: (community: any) => void;
}
const CommunityPaymentsPage = ({
  community,
  user,
  paymentPreference,
  onCommunityUpdate,
  onPaymentPreferenceUpdate = (
    payload: any,
    onSuccess: (_: PaymentPreference) => void,
    onFailed: (_: any) => void
  ) => {},
}: CommunityPaymentsProps) => {
  if (!user) {
    return <LoginRequiredView />;
  }
  if (!community) {
    return (
      <div className="h-96 flex items-center place-content-center w-full">
        <Loader />
      </div>
    );
  }
  return (
    <div className="CommunityPaymentsPage theme-bg-surface rounded mb-10">
      <div className="main-content">
        {/* manage payment gateways and taxes selections */}
        <div className="p-4">
          <div className="pb-3">
            <Label variant="t1">Manage your payment gateways.</Label>
          </div>
          {/* currency selector */}
          <ViewCommunityDefaultCurrency
            community={community}
            onCommunityUpdate={onCommunityUpdate}
          />
          <PaymentMethodSelectionComponent
            community={community}
            user={user}
            onPaymentPreferenceUpdate={onPaymentPreferenceUpdate}
            paymentPreference={paymentPreference}
          />
        </div>
      </div>
    </div>
  );
};

export default CommunityPaymentsPage;
